import React, { useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import Logo from "../Components/Logo";

import useOTPHandler from "../Services/useOTPHandler";
const Success = () => {
  
  let { customerToken } = useOTPHandler.useContainer();
  let history = useHistory()

  useEffect(() => {
    if (!customerToken ) {
      history.push("/");
    }
  }, [])

  const redirectAction = () => {
    window.location.href = `${process.env.REACT_APP_WEMOVE_APP_URL}/login/${customerToken}`
  };

  return (
    <Card className="main-card d-flex align-items-center justify-content-center p-5 h-100 w-100">
        <Logo />
        <h3 className="">Congratulations!</h3>
        <h5 className="text-center">
          Your account has been successfully linked to <strong>JoyRide!</strong>{" "}
        </h5>
        <p className="success-text">
          Pay cashless using your newly linked <br />
          <strong>JoyRide</strong> Account!
        </p>
          <>
            <Button className="jr-btn" onClick={redirectAction}>
              Back to Merchant
            </Button>
          </>
      </Card>
  );
};

export default Success;
